import { useCallback, useEffect, useState } from "react";
import { getDetailedCourse } from "../../../../services/StudentPortal/StudentCourseApi";
import { handleApiError } from "../../../../utils/errorHandler";

// Same unconfirmed-success-shape caveat as useStudentCourses.js — only the
// {success:false, message} error case is confirmed so far.
const extractCourse = (data) => {
  if (!data || data.success === false) return null;
  if (Array.isArray(data)) return data[0] || null;
  if (Array.isArray(data?.data)) return data.data[0] || null;
  if (data?.data && typeof data.data === "object") return data.data;
  return data;
};

/** Fetches one Moodle course's full content details by id for StudentCourseDetail.js. */
export const useStudentCourseDetail = (id) => {
  const [course, setCourse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCourse = useCallback(async () => {
    if (!id) {
      setCourse(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const response = await getDetailedCourse(id);
      setCourse(extractCourse(response?.data));
    } catch (error) {
      if (error?.response?.status !== 404) {
        handleApiError(error);
      }
      setCourse(null);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchCourse();
  }, [fetchCourse]);

  return { course, isLoading, refetch: fetchCourse };
};
